import React from 'react';
import styled from 'styled-components';
import { buttonBackground } from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  /*flex: 1;*/
  flex-direction: column;
`;

const TableHeader = styled.div`
  background-color: #00518E;
  color: #fff;
  font-size: 1.5rem;
  border-radius: 6px 6px 0px 0px;
  border: none;
  text-align: center;
  padding: 15px;
`;

const ColumnHeaderRow = styled.div`
  display:flex;
  flex-direction: row;
`;

const TableColumnHeader = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  border: 1px solid ${buttonBackground};
  font-size: 1rem;
  font-weight: bold;
  color: ${buttonBackground};
  padding: 10px;
  text-align: center;
`;

const CellRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const TableCell = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  font-weight: bold;
  border: 1px solid ${buttonBackground};
  padding: 10px;
  text-align: center;
`;

const Text = styled.div`
  color: red;
  font-weight: bold;
`;

const rowCellFirst = {
  borderRadius: '0px 0px 0px 6px'
}

const rowCellLast = {
  borderRadius: '0px 0px 6px 0px'
}

const FoundOperator = (props) => {
  const { foundOperator } = props;
  const operatorName = foundOperator?.name;
  const accounts = foundOperator?.avfuelAccounts;

  const getStyle = (account, position) => {
    if (account === accounts[accounts.length -1]) {
      return position === 0 ? rowCellFirst : rowCellLast
    }
  }
console.log('foundOperator', foundOperator)
  return (
    <Container>
      <div className="row">
        <TableHeader className="col-12">
          {foundOperator.name}
        </TableHeader>
      </div>
      <ColumnHeaderRow className="row">
        <TableColumnHeader className="col-4">
          Fly Louie Operator Name
        </TableColumnHeader>
        <TableColumnHeader className="col-4">
          Avfuel Account Name
        </TableColumnHeader>
        <TableColumnHeader className="col-4">
          Avfuel Bill-To Codes
        </TableColumnHeader>
      </ColumnHeaderRow>
      {foundOperator?.avfuelAccounts?.map((account) => (
        <CellRow className="row" key={account.name}>
          <TableCell className="col-4" style={getStyle(account, 0)}>
            {operatorName}
          </TableCell>
          <TableCell className="col-4">
            {account?.name}
          </TableCell>
          <TableCell className="col-4" style={getStyle(account, 2)}>
            {account.accountNumber}
          </TableCell>
        </CellRow>
      ))}
      {foundOperator?.avfuelAccounts && foundOperator?.avfuelAccounts?.length > 1 ?
        <div className="row">
          <Text>
            Note: Multiple Avfuel accounts exist for the same aircraft or fleet.
            Please confirm with the Pilot or Operator as to which Bill-To
            code to use.
          </Text>
        </div> :
        <br/>
      }
    </Container>
  )
}

export default FoundOperator;

function getOperatorName(operator) {

}
